import IconGreenCheck, {
	IconGreenCheckProps as _IconGreenCheckProps,
} from './IconGreenCheck';

export { IconGreenCheck };
export type IconGreenCheckProps = _IconGreenCheckProps;
